import { Theme, Typography, styled } from '@material-ui/core';

export const FiltersWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  minWidth: 420,
  [theme.breakpoints.down('xs')]: {
    minWidth: '100%',
  },
}));

export const MainLabel = styled(Typography)({
  display: 'block',
});

export const TrajectoryWrapper = styled('div')<Theme>(({ theme }) => ({
  position: 'absolute',
  top: '5rem',
  left: 0,
  width: '100%',
  height: '4.8rem',
  background: theme.palette.grey['100'],
  boxShadow: theme.config.defaultBoxShadow,
  zIndex: 1,
  padding: '0.5rem 6rem 0.5rem 1rem',
  '&.fullscreen': {
    top: 0,
    transform: 'scale(1.25)',
    transformOrigin: 'top left',
  },
}));

export const BookOverviewWrapper = styled('div')<Theme>(({ theme }) => ({
  flex: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
  // background: 'blue',
}));

export const ScoreProgressWrapper = styled('div')({
  display: 'inline-block',
});
